import { Injectable, ErrorHandler } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthService, IdentityService } from '../services';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {



  constructor(private authenticationService: AuthService, private identityService: IdentityService) { }


  



  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let currentUser = this.identityService.user;
    if (currentUser && currentUser.Token) {
      request = this.authenticationService.addToken(request, currentUser.Token);
    }

    return next.handle(request).pipe(
      catchError(errordata => {
        //logtoken console.log({ 'request': request, 'error': errordata });

        if (request.url.endsWith("/RefreshToken"))
          this.authenticationService.isRefreshing = false;

        if (errordata.status === 401) {

          // need to implement logout
          if (!request.url.endsWith("/RefreshToken")) {
            // refresh token logic
            var that = this;
            //this.authenticationService.waitUntil(that);
            if (this.identityService.isLoggedIn) {
              //this.authenticationService.isRefreshing = true
              //logtoken console.log('call handleRefreshToken');
              try {
                return this.authenticationService.handleRefrehToken(request, next).pipe(catchError(err => {
                  console.log({ 'error handleRefrehToken': err });
                  return new Observable<HttpEvent<any>>();
                }));
              } catch (err) {
                console.log({ 'error handleRefrehToken': err });
                this.authenticationService.isRefreshing = false;
              }
            }
            return new Observable<HttpEvent<any>>();
          }
          else {
            if (this.identityService.isLoggedIn) {
              //logtoken console.log({ 'error refresh Token': errordata });
              this.authenticationService.logOut();
              this.authenticationService.isRefreshing = false;
            }
            return new Observable<HttpEvent<any>>();
          }

        }
        return throwError(errordata);
      })
    );
  }




  
}
